import gql from 'graphql-tag';

export default gql`
  mutation AuthenticateUser($email: String!, $password: String!) {
    authenticateUser(data: { email: $email, password: $password }) {
      token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/AuthenticateUser.ts